export function asyncRun(fn) {
  setTimeout(fn, 0);
}